var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMappin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.03809 6.18164C9.03809 7.60547 10.0312 8.80078 11.376 9.07324V15.7002C11.376 17.6865 11.7188 18.75 11.9912 18.75C12.2637 18.75 12.5977 17.6953 12.5977 15.7002V9.07324C13.9424 8.80078 14.9443 7.60547 14.9443 6.18164C14.9443 4.54688 13.6348 3.21094 11.9912 3.21094C10.3477 3.21094 9.03809 4.54688 9.03809 6.18164ZM11.1123 6.30469C10.5762 6.30469 10.1016 5.83887 10.1016 5.29395C10.1016 4.74023 10.5762 4.2832 11.1123 4.2832C11.666 4.2832 12.123 4.74023 12.123 5.29395C12.123 5.83887 11.666 6.30469 11.1123 6.30469ZM11.9912 21.7471C17.001 21.7471 20.1123 20.0947 20.1123 18.1699C20.1123 16.0781 16.5879 14.7598 14.1094 14.7246V15.7178C16.0078 15.7529 18.7764 16.6846 18.7764 18.0293C18.7764 19.6025 15.8672 20.6836 11.9912 20.6836C8.11523 20.6836 5.20605 19.6113 5.20605 18.0293C5.20605 16.6846 7.97461 15.7529 9.88184 15.7178V14.7246C7.40332 14.7598 3.87891 16.0781 3.87891 18.1699C3.87891 20.0947 6.99023 21.7471 11.9912 21.7471Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappin);
export default __webpack_public_path__ + "static/media/Map pin.1e8ce5b77b62c33e4c251af82125d096.svg";
export { ForwardRef as ReactComponent };